import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { DsIconSize, DsPackName } from '../../icon.interface';
import { DsIconService } from '../../services/icon.service';
import { DsBreakpointService } from '@skyeng/libs/shared/ui-kit-v2/layout';

@Component({
  selector: 'ds-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsIconComponent implements OnInit, OnChanges {
  @Input() name?: string;
  @Input() pack: DsPackName = 'default';
  @Input() size: DsIconSize = 'm';
  @Input() svgContent?: string;
  // native class attr will write here. Needs to save outer classes due to overriding class attr by HostBinding
  @Input() class = '';

  @HostBinding('class') hostClasses: string;

  constructor(private dsIconService: DsIconService, private dsBreakpointService: DsBreakpointService) {}

  ngOnInit(): void {
    this.setSizeClass();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.name || changes.pack || changes.size) && this.name && this.pack && this.size) {
      this.dsIconService.createIconSymbol(this.pack, this.name!, this.getSize());
    }

    if (changes.size) {
      this.setSizeClass();
    }
  }

  getSymbolId(): string {
    return this.dsIconService.constructSymbolId(this.pack, this.name!, this.getSize());
  }

  private getSize(): DsIconSize {
    return this.dsBreakpointService.isSmall() ? 's' : this.size;
  }

  private setSizeClass(): void {
    this.hostClasses = this.name && this.getSize() ? [this.class, `-size-${this.getSize()}`].join(' ') : this.class;
  }
}
